var scroll_element = '.home-body';

// gsap.registerPlugin(ScrollTrigger);

// function check_device() {
//   var winW = window.innerWidth;
//   if (winW > 992 && !isIE11) {
//     isMobile = false;
//     scroll_element = '.scroll-content';
//   } else {
//     isMobile = true;
//     scroll_element = document.body;
//   }
// }
// function check_delay() {
//   if (!isHeaderLoaded) {
//     intro_delay = 1.7;
//   } else {
//     intro_delay = 1;
//   }
// }

// set scroller depending on device
// check_device();

// Setup
// const scroller = document.querySelector('.scroller');

// const bodyScrollBar = Scrollbar.init(scroller, { damping: 0.1, delegateTo: document, alwaysShowTracks: true });

// ScrollTrigger.scrollerProxy(".scroller", {
//   scrollTop(value) {
//     if (arguments.length) {
//       bodyScrollBar.scrollTop = value;
//     }
//     return bodyScrollBar.scrollTop;
//   }
// });

// bodyScrollBar.addListener(ScrollTrigger.update);

// ScrollTrigger.defaults({ scroller: scroller });


// image scaling scrub for images
gsap.utils.toArray('.sitebody .to-scale').forEach(function (section) {
  var tl_scale = gsap.timeline({
    scrollTrigger: {
      // scroller: scroll_element,
      trigger: section,
      start: 'top bottom', // when the top of the trigger hits the top of the viewport
      end: 'bottom top',
      scrub: 1,
    },
  });

  // add animations and labels to the timeline
  tl_scale.fromTo(section.querySelector('img'), { scale: 1 }, { scale: 1.2 });
});
//



// const showAnim = gsap.from('.navbar', {
//   yPercent: -116,
//   paused: true,
//   duration: 0.2
// }).progress(1);

// ScrollTrigger.create({
//   start: "top top",
//   end: 99999,
//   onUpdate: (self) => {
//     self.direction === -1 ? showAnim.play() : showAnim.reverse()
//   }
// });


// const whatsAppIcon = gsap.to('.fixed-chat-icon', {
//   y: 85,
//   paused: true,
//   duration: 0.2
// }).progress(1);

// ScrollTrigger.create({
//   start: "top top",
//   end: 99999,
//   onUpdate: (self) => {
//     self.direction === -1 ? whatsAppIcon.play() : whatsAppIcon.reverse()
//   }
// });

// ScrollTrigger.create({
//   trigger: ".side_navigation_bar",
//   start: "top top",
//   pin: true,
//   pinSpacing: false
// });

// // filter-side-nav
// ScrollTrigger.create({
//   trigger: ".main-body",
//   start: "top top",
//   end: "+=500",
//   pin: ".filter-side-nav",
//   pinSpacing: false
// });